 let skills = [
    {name: "Computer Vision"},
    {name: "On Device Model Deployment"},
    {name: "TinyML"},
    {name: "Data Visualization"},
    {name: "Predictive Analysis"},
    {name: "Statistical Modeling"},
    {name: "Mentoring"},
    {name: "Clustering & Classification"},
    {name: "Data Analysis"},
    {name: "Data Mining"},
    {name: "Web Scraping"},
    {name: "ML Algorithms"},
    {name: "Model Deployment"},
    {name: "MLOps"},
    {name: "Big Data"},
]

export default skills